import React, { Component } from "react";

import "./Tree.less";

export default class Tree extends Component {
  render() {
    const style = {
      ...this.props.style,
      width: this.props.width,
    };
    return (
      <div
        className={"nano-panel-tree " + (this.props.className || "")}
        style={style}
      >
        {this.props.children}
      </div>
    );
  };
}
